import {HttpServices} from "../Helpers";

export const GetAllPortalData = async ({language_uuid}) =>
  await HttpServices.get(
    `${process.env.REACT_APP_DOMIN_PHP_API_GET}/api/recruiter/career/portal/${process.env.REACT_APP_VERSION_API_V2}/get-internal-portal`,
    {
      params: {language_uuid},
    }
  )
    .then((data) => data)
    .catch((error) => error.response);
